import React, {
  CSSProperties,
  FC, useEffect, useRef, useState,
} from 'react';
import { aiChatWaiting } from '../../../../../../../assets/base64Images/ai/aiChatWaiting';
import TempFieldUtils from '../../../../../../../lib/TempFieldUtils';

const RobotLoading: FC<Props> = ({
  flowId,
  style,
}) => {
  const [loading, setLoading] = useState<boolean>(true);
  const [ShowLoading, setShowLoading] = useState<boolean>(true);
  const loadingRef = useRef<any>();

  useEffect(() => {
    if (!loading && loadingRef.current && flowId && TempFieldUtils.aiFlowIds.includes(flowId)) {
      const offsetWidth = loadingRef.current.offsetWidth;
      let marginLeft = 0;
      const interval = setInterval(() => {
        marginLeft += 5;
        loadingRef.current.style.marginLeft = `${-marginLeft}px`;
        if (marginLeft >= offsetWidth) {
          setShowLoading(false);
          clearInterval(interval);
        }
      }, 10);

      // 组件卸载时清除定时器
      return () => clearInterval(interval);
    }
  }, [loading]);

  useEffect(() => {
    setTimeout(() => {
      checkNeedHideLoading();
    }, 100);
  }, []);

  const checkNeedHideLoading = () => {
    if (flowId) {
      if (TempFieldUtils.aiFlowIds.includes(flowId)) {
        setLoading(false);
      }
      else {
        setTimeout(() => {
          checkNeedHideLoading();
        }, 100);
      }
    }
  };

  if (!ShowLoading) {
    return <></>;
  }

  return (
    <img
      ref={loadingRef}
      src={aiChatWaiting}
      style={{ width: 74, height: 41, ...style }}
    />
  );
};

export interface Props {
  loading?: boolean;
  // 流程ID，同一个流程下的loading，只要在流程ID中就不显示这个loading
  flowId?: string;
  style?: CSSProperties;
}

export default RobotLoading;
